export const NAME_AND_CITY_NOT_ALLOWED_SYMBOLS = /[.\\~`!@#$£±%^&*()_+={}/?|:;"<>,\][]/;
export const ADDRESS_NOT_ALLOWED_SYMBOLS = /[\\~`!@$£±%^*_={}?|:;"<>\][]/;
export const WHITE_START_OR_END_REGEXP = /(?:^\s+\S*)|(?:\S*\s+$)/;
export const START_WITH_LETTER_REGEXP = /^[A-Za-z]/;
export const CONTAIN_UPPERCASE_LETTER_REGEXP = /[A-Z]/;
export const CONTAIN_LOWERCASE_LETTER_REGEXP = /[a-z]/;
export const CONTAIN_SYMBOL_REGEXP = /[^A-Za-z\s\d\w]/;
export const CONTAIN_NUMBER_REGEXP = /[0-9]/;
export const NUMBERS_OR_SPACE = /^(?=.\d[\d]+$)/;
export const NUMBERS_ONLY_REGEXP = /^\d+$/;
export const NUMBERS_ONLY_DECIMALS_ALLOWED = /^\d+(\.\d{1,2})?$/;
export const START_WITH_BANNED_WORDS =
  /^(host|moderator|Accts|Cnslt|CSR|DAD|FPP|Host|HR|IT|Mgmt|Mktg|Pmts|Soft|Staff|Support|psdeadbl|Tilter|CAGE|DGE)/i;
export const PO_BOX_ADDRESS_REGEX = /(\bp[.\s\\/]*[box]+[.\s]*\b)|\bbx\b|\bbox\b/i;
export const CONTAIN_SPECIAL_CHARACTER_REGEXP = /[^\x20-\x7F]+/;
export const CONTAIN_LATIN_CHARACTERS_ONLY = /[^\x20-\x7FÀ-ÿ]+/;
export const CONTAIN_INT_AND_DEC_NUMBERS = /^[+-]?\d+(\.\d+)?$/;
export const CONTAIN_LATIN_AND_SPANISH_CHARACTERS_ONLY =
  /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\u00F1\u00D1'_:-]+$/u;
export const RESTRICTED_SYMBOLS_SHORT = /[{}<>=]/;
export const SPACE_BETWEEN_CHAR_AND_INT = /\d[^\d\s]|[^\d\s]\d/;
export const CANADIAN_ZIP_CODE_FORMAT = /[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/;
export const USER_ID_FRANCE_REGEX = /[^A-Za-z0-9+_/]+/;
export const IBAN_VALIDATION = /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/;
